import { FilterConfig } from './DynamicFilters';

export const getAppliedFiltersCount = (filterArray: string[] | any): number => {
  // Check if filterArray is an array and has elements
  if (Array.isArray(filterArray) && filterArray.length > 0) {
    // Use a Set to store unique filter parts, excluding those containing 'CreatedById'
    const uniqueFilterParts = new Set(filterArray.filter(part => !part.includes('CreatedById')));

    // The size of the Set gives the count of unique filters
    return uniqueFilterParts.size;
  } else {
    return 0; // Return 0 if filterArray is not an array or is empty
  }
};

export function getDefaultFilterValue(propertyName: string, filtersConfig: FilterConfig[]) {
  const filterConfig = filtersConfig.find(config => config.propertyName === propertyName);

  if (!filterConfig) return null;

  switch (filterConfig.type) {
    case 'text':
      return filterConfig.multiSelect ? [] : '';
    case 'number':
      return [filterConfig.rangeMin || 0, filterConfig.rangeMax || 100];
    case 'date':
      return { start: null, end: null }; // or set to default dates if required
    case 'lookup':
      return filterConfig.multiSelect ? [] : null;
    case 'boolean':
      return null; // Default for boolean type is typically false unless specified otherwise
    default:
      return null;
  }
}
